import { render, staticRenderFns } from "./DeviceImagesCarousel.vue?vue&type=template&id=0dcc3be6&scoped=true"
import script from "./DeviceImagesCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceImagesCarousel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DeviceImagesCarousel.vue?vue&type=style&index=0&id=0dcc3be6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcc3be6",
  null
  
)

export default component.exports